import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export abstract class ServiceBase {

  protected abstract get serviceDomain(): string;

  protected get baseUrl(): string {
    return `${environment.sehApiUrl}${this.serviceDomain}`;
  }

  constructor(protected httpClient: HttpClient) { }

  getAll(): Observable<any> {
    return this.httpClient.get(this.baseUrl);
  }

  get(id: any): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/${id}`);
  }

  add(value: any): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl, value);
  }

  update(id: any, value: any): Observable<any> {
    return this.httpClient.put<any>(`${this.baseUrl}/${id}`, value);
  }

  delete(id: any): Observable<any> {
    return this.httpClient.delete<any>(`${this.baseUrl}/${id}`)
  }
}
